<template>
    <div class="loading-indicator">
        <div class="loading-square"></div>
        <div class="loading-square"></div>
        <div class="loading-square"></div>
        <div class="loading-square"></div>
        <div class="loading-square"></div>
    </div>
</template>

<script>
export default {
    name: "LoadingAnimation"
};
</script>

<style scoped>
@-webkit-keyframes loadingAnimation {
    0% {
        opacity: 0;
    }

    20% {
        opacity: 0.2;
    }

    40% {
        opacity: 0.4;
    }

    60% {
        opacity: 0.6;
    }

    80% {
        opacity: 0.8;
    }

    100% {
        opacity: 1;
    }
}

@keyframes loadingAnimation {
    0% {
        opacity: 0;
    }

    20% {
        opacity: 0.2;
    }

    40% {
        opacity: 0.4;
    }

    60% {
        opacity: 0.6;
    }

    80% {
        opacity: 0.8;
    }

    100% {
        opacity: 1;
    }
}

.loading-indicator {
    text-align: center;
}

.loading-indicator .loading-square {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 8px;
    -webkit-animation: loadingAnimation 0.8s ease-in-out infinite;
    animation: loadingAnimation 0.8s ease-in-out infinite;
    background-color: var(--tiffany);
}

.loading-indicator .loading-square:nth-child(1) {
    -webkit-animation-delay: 0;
    animation-delay: 0;
}

.loading-indicator .loading-square:nth-child(2) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}

.loading-indicator .loading-square:nth-child(3) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

.loading-indicator .loading-square:nth-child(4) {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
}

.loading-indicator .loading-square:nth-child(5) {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
    margin-right: 0;
}
</style>
